import { Icon } from '@onyx/ui/components/colleague/icon';
import { getClassName, visuallyHideStyles } from '@onyx/ui/style-utils';

import styles from './checkbox.module.css';

type CheckboxVariant = 'primary' | 'error';

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  label: string;
  variant?: CheckboxVariant;
  isIndeterminate?: boolean;
  isInverse?: boolean;
  isDisabled?: boolean;
  isLabelHidden?: boolean;
  className?: string;
};

export const Checkbox = ({
  id,
  label,
  variant = 'primary',
  isIndeterminate = false,
  isInverse = false,
  isDisabled = false,
  isLabelHidden = false,
  className,
  ...rest
}: CheckboxProps) => {
  const variantMap: Record<CheckboxVariant, string> = {
    primary: styles.variantPrimary,
    error: styles.variantError,
  };

  const classNames = getClassName([
    styles.checkbox,
    variantMap[variant],
    isInverse && styles.inverse,
    className,
  ]);

  const labelClassNames = getClassName([
    styles.checkboxLabel,
    isLabelHidden && visuallyHideStyles.visuallyHide,
  ]);

  const tickIconName = isIndeterminate
    ? 'CheckIndeterminateSmall'
    : 'CheckSmall';

  return (
    <div className={styles.checkboxWrapper}>
      <div className={styles.checkboxContainer}>
        <input
          type="checkbox"
          id={id}
          disabled={isDisabled}
          className={classNames}
          {...rest}
        />
        <span className={styles.tick}>
          <Icon name={tickIconName} size={18} />
        </span>
      </div>
      <label htmlFor={id} className={labelClassNames}>
        {label}
      </label>
    </div>
  );
};
